export default __webpack_public_path__ + "static/rosetta_stone_kids-fd1d13eb5750c8992858f455e977c8b6.png";